import React from "react";
import {
  LegalPageLayout,
  LegalSection,
  TocItem,
} from "pages/website/LegalPageLayout";

const DATA_POLICY_TOC: TocItem[] = [
  { id: "data-ownership", label: "Data Ownership" },
  { id: "corporate-accounts", label: "Corporate Accounts" },
  { id: "analytics-tracking", label: "Analytics & Tracking" },
];

const DataPolicyPage: React.FC = () => {
  return (
    <LegalPageLayout
      title="Data Policy"
      icon="📊"
      tocItems={DATA_POLICY_TOC}
    >
      <LegalSection id="data-ownership" number={1} title="Data Ownership">
        <ul>
          <li>Users and companies retain full ownership of their data</li>
          <li>YourQcard acts only as a data processor</li>
        </ul>
      </LegalSection>

      <LegalSection id="corporate-accounts" number={2} title="Corporate Accounts">
        <p>For company packages:</p>
        <ul>
          <li>Company admins manage employee cards</li>
          <li>Admins are responsible for employee data accuracy</li>
          <li>
            Removed employees' data can be deactivated or deleted by the
            company admin
          </li>
        </ul>
      </LegalSection>

      <LegalSection
        id="analytics-tracking"
        number={3}
        title="Analytics & Tracking"
      >
        <ul>
          <li>Basic analytics are used to improve service quality</li>
          <li>No personal profiling or selling of analytics data</li>
        </ul>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default DataPolicyPage;
